import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultIllustrationInfo } from '../interfaces/IllustrationIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C503IllustrationDeleteProps {
  execIllustrationDelete: (deviceId: string, phrase_text: string) => Promise<ResultIllustrationInfo>
  loading: loadStatus
}
// C503 図解削除API呼出
export const useC503IllustrationDelete = (): C503IllustrationDeleteProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execIllustrationDelete = async (deviceId: string, text: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.delete(
        `${buildDeviceUrl(deviceId, apiUrl.illustrationsPath)}`,
        {
          headers: header,
          data: {
            text,
            language: 'ja',
          },
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execIllustrationDelete, loading }
}
